import type { MetricName } from '@sprintpulse/shared';

export const queryKeys = {
  teams: () => ['teams'] as const,
  products: () => ['products'] as const,
  sprints: (teamId: string) => ['sprints', teamId] as const,
  sprintSummary: (teamId: string, sprintId: string) =>
    ['sprint-summary', teamId, sprintId] as const,
  metricTrend: (teamId: string, metric: MetricName, sprints: number) =>
    ['trend', teamId, metric, sprints] as const,
  dashboard: () => ['dashboard'] as const,
  insights: (teamId: string, sprintId: string) => ['insights', teamId, sprintId] as const,
  roadmap: (productId?: string) => ['roadmap', productId ?? 'default'] as const,
  roadmapDetails: (productId?: string) => ['roadmap-details', productId ?? 'default'] as const,
  roadmapInsights: (productId?: string) => ['roadmap-insights', productId ?? 'default'] as const,
  preferences: () => ['preferences'] as const,
};

export const adminQueryKeys = {
  teams: () => ['admin', 'teams'] as const,
  team: (id: string) => ['admin', 'teams', id] as const,
  products: () => ['admin', 'products'] as const,
  product: (id: string) => ['admin', 'products', id] as const,
};
